import {css} from '@emotion/react'

export const productDetailsStyles = css`
    h3 {
        background-color: var(--chakra-colors-whiteSmoke);
        font-size: var(--chakra-fontSizes-sm);
        padding: 3px;
        width: fit-content;
        margin-bottom: 8px;
    }
    .longDescription {
        font-size: var(--chakra-fontSizes-md);
        padding-top: 20px;
    }
    .longDescriptionTitle {
        font-size: var(--chakra-fontSizes-md);
    }
    .longDescriptionText {
        font-size: var(--chakra-fontSizes-md);
        color: var(--chakra-colors-darkGray);
        padding-top: 4px;
    }
    .secondBlock {
        padding-top: 20px;
    }
    ul {
        list-style-type: none;
    }
    li {
        position: relative;
        padding-left: 8px;
        margin-bottom: 8px;
    }
    li::before {
        content: '';
        position: absolute;
        top: 5px;
        left: 0;
        width: 0;
        height: 0;
        border-top: 3px solid transparent;
        border-bottom: 3px solid transparent;
        border-left: 4px solid var(--chakra-colors-darkGray);
    }
`
